import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import NProgress from 'nprogress'
// import store from './store/store'
import NotFound from './views/NotFound.vue'
import NetworkIssue from './views/NetworkIssue.vue'
import { allPermissionAccount } from './const'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter(to, from, next) {
        const loggedIn = localStorage.getItem('user')
        if (loggedIn) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/',
      name: 'home',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: resolve => require([`@/components/layout/layout`], resolve),
      children: [
        {
          path: '/',
          component: resolve => require([`@/views/Home.vue`], resolve),
          meta: {
            requireAuth: true,
            permissions: [
              'Dashboard.Pod Accel.View',
              'Dashboard.Pod Capacitance.View',
              'Dashboard.Pod Data Stream.View'
            ]
          }
        },
        {
          path: '/products',
          component: resolve => require([`@/views/Products.vue`], resolve),
          meta: {
            requireAuth: true,
            permissions: [
              'Products.Manufacturers.View',
              'Products.Product Description.View',
              'Products.Product Characteristics.View',
              'Products.Run.View',
              'Products.Analyse Runs.View'
            ]
          }
        },
        {
          path: '/pods',
          component: resolve => require([`@/views/Pods.vue`], resolve),
          meta: {
            requireAuth: true,
            permissions: [
              'Pods.Capacitance Readings Chart.View',
              'Pods.Connection Status Chart.View',
              'Pods.Battery Levels Chart.View',
              'Pods.Accelerometer Readings Chart.View',
              'Pods.Temperature Chart.View',
              'Pods.SPO2 Chart.View',
              'Pods.Calibration.View',
              'Pods.Find Data.View',
              'Pods.Diagnostics.View',
              'Pods.Live Data.View'
            ]
          }
        },
        {
          path: '/reports',
          component: resolve => require([`@/views/Reports.vue`], resolve),
          meta: {
            requireAuth: true,
            permissions: ['Reports.Export CSV.Export']
          }
        },
        {
          path: '/production',
          component: resolve => require([`@/views/Production.vue`], resolve),
          meta: {
            requireAuth: true,
            permissions: [
              'Production.Monitoring.View',
              'Production.Test Reports.View',
              'Production.Acceptance Criteria.View',
              'Production.Firmware & Software.View'
            ]
          }
        },
        {
          path: '/manage',
          component: resolve => require([`@/views/Manage.vue`], resolve),
          meta: {
            requireAuth: true,
            permissions: [
              'Manage.Users.View',
              'Manage.Roles.View',
              'Manage.Distributors.View'
            ]
          }
        },
        {
          path: '/backtest',
          component: resolve => require([`@/views/BackTest.vue`], resolve),
          meta: {
            requireAuth: true,
            permissions: ['BackTest.View']
          }
        }
      ],
      beforeEnter(routeTo, routeFrom, next) {
        let user = JSON.parse(localStorage.getItem('user'))
        if (
          routeTo.meta &&
          routeTo.meta.permissions &&
          routeTo.meta.permissions.length &&
          user.username !== allPermissionAccount
        ) {
          let flag = false
          let permissions = JSON.parse(localStorage.getItem('permissions'))
          permissions.forEach(permission => {
            if (routeTo.meta.permissions.indexOf(permission) > -1) {
              flag = true
            }
          })
          if (flag) {
            next()
          } else {
            next('/404')
          }
        } else {
          next()
        }
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/404',
      name: '404',
      component: NotFound
    },
    {
      path: '*',
      redirect: { name: '404' }
    },
    {
      path: '/network-issue',
      name: 'network-issue',
      component: NetworkIssue
    }
  ]
})

router.beforeEach((routeTo, routeFrom, next) => {
  NProgress.start()
  const loggedIn = localStorage.getItem('user')
  if (routeTo.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next('/login')
  }
  next()
})

router.afterEach(() => {
  NProgress.done()
})

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
export default router
